"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useScroll = void 0;
var lodash_1 = require("lodash");
var react_1 = require("react");
/**
 * @param {Function} scrollFn
 * @param {*} options
 * @summary if you dont use options.detectScrollInAllDivs, scroll is detected only at the 'window' level
 */
var useScroll = function (scrollFn, options) {
    if (options === void 0) { options = {}; }
    (0, react_1.useLayoutEffect)(function () {
        var _a;
        scrollFn(); // Run the scroll function once before any scroll to set initial states
        var throttledScrollFn = (0, lodash_1.throttle)(scrollFn, 100);
        var fnToUse = options.noThrottle ? scrollFn : throttledScrollFn;
        window.addEventListener('scroll', fnToUse, (_a = options.detectScrollInAllDivs) !== null && _a !== void 0 ? _a : true); // <-- why 'true' : https://stackoverflow.com/a/32954565 // Use a default value of `true` if `detectScrollInAllDivs` is not provided.
        return function () { return window.removeEventListener('scroll', fnToUse, options.detectScrollInAllDivs); };
    }, [options.loading]);
};
exports.useScroll = useScroll;
